import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errorText } from "@/lib/api";
import { Field, inputClass, GhostButton } from "./fields";

export default function VideoUploadField({ value, onChange, testId }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    const body = new FormData();
    body.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", body, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Clip uploaded.");
    } catch (err) {
      toast.error(errorText(err, "Upload failed."));
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <Field label="Video" hint="Self-hosted MP4/WebM path or link (recommended, e.g. /video/sunseeker-hero.mp4), or a YouTube link. Upload silent MP4 clips up to 60 MB.">
      <div className="flex gap-3">
        <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder="/video/brand-hero.mp4 or https://www.youtube.com/watch?v=…" data-testid={testId} className={inputClass} />
        <GhostButton type="button" onClick={() => fileRef.current?.click()} disabled={uploading} data-testid={`${testId}-upload`} className="shrink-0 inline-flex items-center gap-2">
          <Upload size={12} /> {uploading ? "Uploading…" : "Upload MP4"}
        </GhostButton>
        <input ref={fileRef} type="file" accept="video/mp4,video/webm" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`${testId}-file`} />
      </div>
    </Field>
  );
}
